import { ReactNode } from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { css, styled, StyledProps } from '../../../stitches.config';
import { panelCSS } from '../..';

export const baseMenuItemCSS = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontFamily: '$sans',
  fontSize: '$1',
  lineHeight: '$2',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  height: '$5',
  padding: '$5 $7',
});

export const menuItemCSS = css(baseMenuItemCSS, {
  'position': 'relative',
  'color': '$slate11',
  'cursor': 'pointer',
  'borderRadius': '$small',

  '&:focus-visible': {
    outline: 'none',
    backgroundColor: '$slate4',
    color: 'white',
  },

  '&[data-disabled]': {
    color: '$slate9',
  },
});

export const menuLabelCSS = css(baseMenuItemCSS, {
  color: '$slate11',
  cursor: 'default',
  lineHeight: '$4',
});

export const menuContentCSS = css({
  boxSizing: 'border-box',
  minWidth: 100,
  padding: '$3',
  zIndex: 1,
  backgroundColor: 'white',
  borderRadius: '$medium',
  boxShadow: 'hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px',
});

export const menuSeparatorCSS = css({
  height: 1,
  margin: '$3',
  backgroundColor: '$purple6',
});

const StyledRoot = styled(DropdownMenuPrimitive.Root, {});
const StyledTrigger = styled(DropdownMenuPrimitive.Trigger, {});
const StyledContent = styled(DropdownMenuPrimitive.Content, menuContentCSS, panelCSS);
export const Separator = styled(DropdownMenuPrimitive.Separator, menuSeparatorCSS);
export const Item = styled(DropdownMenuPrimitive.Item, menuItemCSS);
export const Label = styled(DropdownMenuPrimitive.Label, menuLabelCSS);
export const RadioGroup = styled(DropdownMenuPrimitive.RadioGroup, {});
export const Group = styled(DropdownMenuPrimitive.Group, {});

export type DropdownRootProps = StyledProps<DropdownMenuPrimitive.DropdownMenuProps> & {
  trigger: ReactNode;
  triggerProps?: StyledProps<DropdownMenuPrimitive.DropdownMenuTriggerProps>;
  contentProps?: StyledProps<DropdownMenuPrimitive.DropdownMenuContentProps>;
};

export function Root(props: DropdownRootProps) {
  const { children, trigger, triggerProps = {}, contentProps = {}, ...rootProps } = props;

  return (
    <StyledRoot {...rootProps}>
      <StyledTrigger {...triggerProps}>{trigger}</StyledTrigger>
      <StyledContent {...contentProps}>{children}</StyledContent>
    </StyledRoot>
  );
}
